import { getToken } from "../../common/environment_config.es6";
import { apiGet } from "../../common/http_service";

export class TrainingSummaryService {
  static async getTrainingSummary(params = {}) {
    let { trainingId } = params;

    // trainingId: explicit param > global idealStudioTrainingId
    if (!trainingId) {
      trainingId = window.idealStudioTrainingId || "";
    }

    if (!trainingId) {
      throw new Error("trainingId is missing for getTrainingSummary");
    }

    // Base URL: same pattern as sceneAudioService
    if (!window.ideaLibraryRootUrl) {
      throw new Error("ideaLibraryRootUrl not configured for training summary");
    }

    let baseUrl = window.ideaLibraryRootUrl;
    if (!baseUrl.toLowerCase().startsWith("http")) {
      baseUrl = window.location.origin + baseUrl;
    }

    if (!baseUrl.endsWith("/")) {
      baseUrl += "/";
    }

    // Final endpoint: {{baseUrl}}/api/studio/training/{{trainingId}}/summary
    const url = `${baseUrl}api/studio/training/${trainingId}/summary`;

    const headers = {};

    const token = getToken && getToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const tenantId = window.tenantId;
    if (tenantId) {
      headers["Abp.TenantId"] = tenantId;
    }

    const response = await apiGet(url, { headers });
    if (!response.ok) {
      throw new Error(`Training summary request failed with status ${response.status}`);
    }

    return response.json();
  }
}

export default TrainingSummaryService;
